import React, { useState, useEffect } from "react";
import axios from "axios";

import HeaderTitle from "../../components/includes/HeaderTitle";
import SalesSearch from "../../components/deliverys/SalesSearch";
import Paging from "../../components/includes/Paging";
import SalesSearchResult from "../../components/deliverys/SalesSearchResult";
import {
  LoginAfterCheckLogin,
  addThousandPoint,
} from "../../../components/common/Common";
import SalesSearchEmptyResult from "../../components/deliverys/SalesSearchEmptyResult";

const SalesList = ({ setMenuType, setMenuItem }) => {
  LoginAfterCheckLogin(0);

  let columnList = [
    { Header: "차량번호", accessor: "data1", width: 100 },
    { Header: "기사명", accessor: "data2", width: 120 },
    { Header: "운임료(원)", accessor: "data3", width: 90 },
    { Header: "실운행가(원)", accessor: "data4", width: 90 },
    { Header: "지급원가(원)", accessor: "data5", width: 120 },
    { Header: "수익(원)", accessor: "data6", width: 120 },
    { Header: "배차담당자명", accessor: "data7", width: 150 },
    { Header: "선택유무", accessor: "data8", width: 10 },
  ];

  const [varColumnLists, setColumnLists] = useState([]);
  const [varSalesList, setSalesList] = useState([]);
  const [varSearchData, setSearchData] = useState({
    sdate: null,
    edate: null,
    searchTermMode: 0,
    searchOption: "all",
    searchString: "",
  });
  const [varPageNum, setPageNum] = useState(1);
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize, setPageSize] = useState(500);
  const [varMaxNumPage, setMaxNumPage] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const getSalesList = async () => {
    setIsLoading(true);

    const isVehicleNumberMode = varSearchData.searchTermMode === 0;

    const excelSendData = {
      pageNum: "1",
      pageSize: 0,
      searchData: varSearchData,
    };

    await axios
      .post(
        `${process.env.REACT_APP_HOST}${
          isVehicleNumberMode
            ? "/admin_get_sales_list"
            : "/admin_get_sales_list_by_manager"
        }`,
        excelSendData
      )
      .then((res) => {
        const datas = res.data;

        if (datas.retvalue === 1) {
          const results = datas.results;

          let columnList = [];
          let excelArray = [];

          if (isVehicleNumberMode) {
            columnList = [
              { Header: "차량번호", accessor: "data1", width: 100 },
              { Header: "기사명", accessor: "data2", width: 120 },
              { Header: "운임료(원)", accessor: "data3", width: 90 },
              { Header: "실운행가(원)", accessor: "data4", width: 90 },
              { Header: "지급원가(원)", accessor: "data5", width: 120 },
              { Header: "수익(원)", accessor: "data6", width: 120 },
              { Header: "선택유무", accessor: "data7", width: 10 },
              { Header: "id", accessor: "data8", width: 10 },
              { Header: "driver_idx", accessor: "data9", width: 10 },
            ];
            excelArray = results.map((item, index) => ({
              data1: item.vehicle_number,
              data2: item.driver_name,
              data3: addThousandPoint(item.total_price),
              data4: addThousandPoint(item.total_rprice),
              data5: addThousandPoint(item.total_dprice),
              data6: addThousandPoint(item.revenue),
              data7: 0,
              data8: item.id ?? index,
              data9: item.driver_idx,
            }));
          } else {
            columnList = [
              { Header: "배차담당자명", accessor: "data1", width: 150 },
              { Header: "기사명", accessor: "data2", width: 120 },
              { Header: "운임료(원)", accessor: "data3", width: 90 },
              { Header: "실운행가(원)", accessor: "data4", width: 90 },
              { Header: "지급원가(원)", accessor: "data5", width: 120 },
              { Header: "수익(원)", accessor: "data6", width: 120 },
              { Header: "선택유무", accessor: "data7", width: 10 },
              { Header: "id", accessor: "data8", width: 10 },
            ];
            excelArray = results.map((item, index) => ({
              data1: item.manager_name,
              data2: item.driver_name,
              data3: addThousandPoint(item.total_price),
              data4: addThousandPoint(item.total_rprice),
              data5: addThousandPoint(item.total_dprice),
              data6: addThousandPoint(item.revenue),
              data7: 0,
              data8: item.id ?? index,
            }));
          }
          setExcelData(excelArray);
        } else {
          setExcelData([]);
          setIsLoading(false);
        }
      });

    const sendData = {
      pageNum: varPageNum,
      pageSize: varPageSize,
      searchData: varSearchData,
    };

    await axios
      .post(
        `${process.env.REACT_APP_HOST}${
          isVehicleNumberMode
            ? "/admin_get_sales_list"
            : "/admin_get_sales_list_by_manager"
        }`,
        sendData
      )
      .then((res) => {
        const datas = res.data;

        if (datas.retvalue === 1) {
          const results = datas.results;

          // Determine columns and data structure based on search mode

          let columnList = [];
          let newSalesList = [];

          if (isVehicleNumberMode) {
            columnList = [
              { Header: "차량번호", accessor: "data1", width: 100 },
              { Header: "기사명", accessor: "data2", width: 120 },
              { Header: "운임료(원)", accessor: "data3", width: 90 },
              { Header: "실운행가(원)", accessor: "data4", width: 90 },
              { Header: "지급원가(원)", accessor: "data5", width: 120 },
              { Header: "수익(원)", accessor: "data6", width: 120 },
              { Header: "선택유무", accessor: "data7", width: 10 },
              { Header: "id", accessor: "data8", width: 10 },
              { Header: "driver_idx", accessor: "data9", width: 10 },
            ];
            newSalesList = results.map((item, index) => ({
              data1: item.vehicle_number,
              data2: item.driver_name,
              data3: addThousandPoint(item.total_price),
              data4: addThousandPoint(item.total_rprice),
              data5: addThousandPoint(item.total_dprice),
              data6: addThousandPoint(item.revenue),
              data7: 0,
              data8: item.id ?? index,
              data9: item.driver_idx,
            }));
          } else {
            columnList = [
              { Header: "배차담당자명", accessor: "data1", width: 150 },
              { Header: "기사명", accessor: "data2", width: 120 },
              { Header: "운임료(원)", accessor: "data3", width: 90 },
              { Header: "실운행가(원)", accessor: "data4", width: 90 },
              { Header: "지급원가(원)", accessor: "data5", width: 120 },
              { Header: "수익(원)", accessor: "data6", width: 120 },
              { Header: "선택유무", accessor: "data7", width: 10 },
              { Header: "id", accessor: "data8", width: 10 },
            ];
            newSalesList = results.map((item, index) => ({
              data1: item.manager_name,
              data2: item.driver_name,
              data3: addThousandPoint(item.total_price),
              data4: addThousandPoint(item.total_rprice),
              data5: addThousandPoint(item.total_dprice),
              data6: addThousandPoint(item.revenue),
              data7: 0,
              data8: item.id ?? index,
            }));
          }

          setColumnLists(columnList);
          setSalesList(newSalesList);
          setTotalCount(datas.totalcount);
          setMaxNumPage(datas.totalcount - (varPageNum - 1) * varPageSize);
          setIsLoading(false);
        } else {
          setSalesList([]);
          setTotalCount(0);
          setIsLoading(false);
        }
      });
    // Uncomment and modify this for actual API call
    // const response = await axios.post(`${process.env.REACT_APP_HOST}/api_endpoint`, { ... });
  };

  useEffect(() => {
    setMenuType("DELIVERY");
    setMenuItem("SalesList");
    setColumnLists(columnList);
    getSalesList();
  }, [varPageNum, varSearchData]);

  return (
    <div id="admin_contents" className="ad_contents">
      <HeaderTitle varMenuTitle="배차관리" varPageTitle="매출현황" />
      <div className="admin-content">
        <SalesSearch
          varSearchData={varSearchData}
          setSearchData={setSearchData}
          setPageNum={setPageNum}
        />
        {isLoading || varSalesList?.length === 0 ? (
          <SalesSearchEmptyResult />
        ) : (
          <SalesSearchResult
            varColumnLists={varColumnLists}
            varTotalCount={varTotalCount}
            varMaxNumPage={varMaxNumPage}
            varPageNum={varPageNum}
            varPageSize={varPageSize}
            setPageSize={setPageSize}
            varSalesList={varSalesList}
            setSalesList={setSalesList}
            isVehicleNumberMode={varSearchData.searchTermMode === 0}
            excelData={excelData}
          />
        )}

        <div className="paging" style={{ marginBottom: "20px" }}>
          <Paging
            totalCount={varTotalCount}
            pageSize={varPageSize}
            curPage={varPageNum}
            setPage={setPageNum}
          />
        </div>
      </div>
    </div>
  );
};

export default SalesList;
